import { http } from "~/utils";

export default {
    getActivities: async (page = 1, filters = {}) => {
        const request_filters = { ...filters, page };
        return http
            .get("/activity/activity-smp/", {
                params: request_filters
            })
            .then(response => ({
                list: response.data.results,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    getActivityDetail: async activity_id => {
        return http.get(`/activity/activity-smp/${activity_id}/`).then(response => response.data);
    },
    getActivityCustomerTeams: async (search = undefined) => {
        const request_filters = { ...(search ? { search } : {}) };
        return http
            .get("/activity/activity-smp/customer-teams-autocomplete/", {
                params: request_filters
            })
            .then(response => response.data);
    },
    getActivityAutocomplete: async (customer_team, search = "") => {
        const request_filters = { customer_team, search };
        return http
            .get("/activity/activity-smp-form/", {
                params: request_filters
            })
            .then(response => response.data.results);
    },
    poReleaseInstructionsAutocomplete: async (search = "") => {
        const request_filters = { search };
        return http
            .get("/activity/po-release-instruction-form/", {
                params: request_filters
            })
            .then(response => response.data.results.map(item => {
                return item.code;
            }));
    },
    requestReport: async (filters = {}) => {
        return await http
            .post("/activity/activity-smp/report/", filters)
            .then(response => response.data);
    },
    synergyAutocomplete: async (search = "") => {
        // const request_filters = { search };
        return http
            .get("/activity/ssot-synergy-form/")
            .then(response => response.data.results.map(item => item.value));
    },
};
